import * as React from 'react';
import styled from 'styled-components';
import BoxMUI from '@material-ui/core/Box';

import { getMeasureProp, makeMedia } from '../../styles';
import { BoxProps } from './box';


type RootProps = {} & BoxProps

const Root = styled(({ margin, padding, textTransform, css, mediaRules, ...rest }) => <BoxMUI {...rest} />)<RootProps>`
	${p => p.margin && `
		margin: ${getMeasureProp(p.margin)};
	`}
	${p => p.padding && `
		padding: ${getMeasureProp(p.padding)};
	`}
	${p => p.textTransform && `
		text-transform: ${p.textTransform};
	`}
	${p => p.css && `
		${p.css};
	`}

	${(p: RootProps) => makeMedia(p.mediaRules)}
`;

export {
	Root
}
